//
//
//
//
//
//
//

import {base} from '../../common/mixins'

export default {
  name: 'Spin',
  mixins: [base],
  props: {
    size: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    svgSrc: {
      type: String,
      default: '',
    },
  },
  computed: {
    sizeStyle () {
      return {
        width: this.size,
        height: this.size,
      }
    },
    colorStyle () {
      return {
        color: this.color,
      }
    },
    svgStyle () {
      return {
        width: this.size || '100%',
        height: this.size || '100%',
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Spin/index.vue